import type { PlanCode } from '@/models/Billing';

export type { Plan, PlanCode } from '@/models/Billing';

const PLAN_CODE_LABELS: Record<PlanCode, string> = {
  free: 'Free',
  paid: 'Paid',
};

export function formatPlanCode(planCode?: PlanCode | null): string {
  if (!planCode) return 'Free';
  return PLAN_CODE_LABELS[planCode];
}

export function isFreePlan(planCode?: PlanCode | null): boolean {
  return planCode !== 'paid';
}
